module.exports = __webpack_public_path__ + "static/01-c53b67d5ff33211d81f4ca6cf1499d5a.jpg";